<template>
  <div>
    <div
      v-if="sportcomplexen"
      class="flex flex-col m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 bg-gray-100 p-3"
    >
      <div>
        <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
          Verplaats {{ accommodatie.naam }} naar ander sportcomplex
        </p>

        <p class="font-opensans capitalize">
          {{ accommodatie.straat }}, {{ accommodatie.postcode }},
          {{ accommodatie.plaats["naam"] }}
        </p>
      </div>

      <Map
        :latlon="accommodatie.latlon"
        :accommodaties="accommodaties_to_show"
      />
      <div
        class="font-raleway font-semibold text-xl text-mi-blue-500 uppercase mt-4"
      >
        Sportcomplexen in de buurt
      </div>
      <div
        class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 grid-flow-row gap-4"
      >
        <div
          class="bg-gray-300 hover:bg-opacity-25 font-opensans rounded-lg shadow-lg hover:shadow-xl cursor-pointer p-4"
          v-if="has_sibling_accommodaties"
        >
          <button
            class="btn btn-blue"
            @click="moveAccommodatieToNewSportcomplex"
            v-if="hasPermission('update accommodatie')"
          >
            Week accommodatie los van sportcomplex
          </button>
          {{ msg }}
        </div>
        <AccommodatieClusterCard
          v-for="sportcomplex in sportcomplexen"
          v-bind:key="sportcomplex.id"
          :sportcomplex="sportcomplex"
          v-on:showOnMap="handleShowOnMap"
        />
      </div>

      <div>
        <hr class="border-gray-300 border" />
      </div>
    </div>
    <div
      v-else
      class="flex m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 p-3"
    >
      <div class="m-auto">
        <img src="../../assets/logo.svg" class="w-64 pl-8 mt-32" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Map from "./MoveToSportcomplexMap";
import AccommodatieClusterCard from "./AccommodatieClusterCard";
import { get } from "../../store/store";

export default {
  name: "AccommodatieHome",
  components: {
    Map,
    AccommodatieClusterCard
  },
  data() {
    return {
      msg: null,
      accommodaties_in_proximity: [],
      sportcomplex_to_show: false,
      sportcomplexen: []
    };
  },
  created: async function() {
    await this.loadSportcomplexByAccommodatieId(this.$route.params.id);
    this.accommodaties_in_proximity = await get(
      `locaties/get_accommodaties_in_distance/${this.$route.params.id}/`
    );
    this.sportcomplexen = Object.entries(
      this.accommodaties_in_proximity.reduce(
        (sportcomplexen, current_accommodatie) => {
          if (!(current_accommodatie.sportcomplex.id in sportcomplexen)) {
            sportcomplexen[current_accommodatie.sportcomplex.id] = [];
          }
          sportcomplexen[current_accommodatie.sportcomplex.id].push(
            current_accommodatie
          );

          return sportcomplexen;
        },
        {}
      )
    ).map(([id, accommodaties]) => ({ id, accommodaties }));
  },
  computed: mapState({
    accommodatie: function(state) {
      // we addded a check on presence of the current_accommodatie object otherwise computed just does not run further
      // not sure why
      if (!state.backend_data.current_accommodatie) return null;
      if (
        this.$route.params.id !== state.backend_data.current_accommodatie.id
      ) {
        return null;
      }
      return state.backend_data.current_accommodatie;
    },
    has_sibling_accommodaties: function() {
      return (
        this.$store.state.backend_data.current_sportcomplex.accommodaties
          .length > 1
      );
    },
    accommodaties_to_show: function() {
      if (!this.sportcomplex_to_show) return [];
      return this.sportcomplexen.find(
        sportcomplex => sportcomplex.id === this.sportcomplex_to_show
      ).accommodaties;
    }
  }),
  methods: {
    ...mapActions(["loadAccommodatie", "loadSportcomplexByAccommodatieId"]),
    getPc: async function() {
      const plaats = await this.$store.dispatch(
        "getPlaatsByPostcode",
        this.accommodatie["postcode"]
      );
      this.accommodatie.plaats["naam"] = plaats["naam"];
      this.accommodatie.plaats["id"] = plaats["id"];
    },
    hideMsg: function() {
      this.msg = null;
    },
    handleShowOnMap: function(id) {
      this.sportcomplex_to_show = id;
    },
    moveAccommodatieToNewSportcomplex: async function() {
      const [ok, msg] = await this.$store.dispatch(
        "moveAccommodatieToNewSportcomplex",
        {
          accommodatie_id: this.$route.params.id
        }
      );

      if (ok) {
        this.msg = "Gegevens succesvol opgeslagen";
        this.$router.push({
          name: "Accommodatie",
          params: { id: this.$route.params.id }
        });
      } else {
        this.msg = msg;
      }
    }
  },
  watch: {
    msg(newvalue) {
      if (this.msg) {
        setTimeout(this.hideMsg, 5000);
      }
    }
  }
};
</script>
